// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"styles_Pagination__3kXRq","link":"styles_link__1BmkX","active":"styles_active__3le--","dots":"styles_dots__2jOd9"};